import React from 'react';
import {
  Award,
  BadgeCheck,
  BarChart3,
  Bell,
  Boxes,
  CheckCircle,
  Clock,
  Construction,
  Container,
  Download,
  Factory,
  FileText,
  Gavel,
  Globe,
  Headphones,
  Lock,
  LucideIcon,
  Mail,
  MapPin,
  Phone,
  Play,
  Radio,
  Search,
  Shield,
  ShieldCheck,
  Smartphone,
  Star,
  TrendingUp,
  Truck,
  Users,
  Wallet,
  Zap,
} from 'lucide-react';

// Icons the admin can pick for stats, chips and feature cards. The landing
// content stores the key only, never a component.
export const LANDING_ICONS: Record<string, LucideIcon> = {
  Gavel,
  Users,
  Shield,
  ShieldCheck,
  Radio,
  Boxes,
  Clock,
  TrendingUp,
  CheckCircle,
  Download,
  Truck,
  Factory,
  Construction,
  Container,
  Phone,
  Mail,
  MapPin,
  Play,
  Star,
  Award,
  BadgeCheck,
  Globe,
  Zap,
  Lock,
  FileText,
  BarChart3,
  Headphones,
  Wallet,
  Search,
  Bell,
  Smartphone,
};

export const LANDING_ICON_NAMES = Object.keys(LANDING_ICONS);

export const renderLandingIcon = (
  name: string,
  className = 'w-5 h-5',
  strokeWidth?: number
): React.ReactNode => {
  const Icon = LANDING_ICONS[name] || Star;
  return <Icon className={className} strokeWidth={strokeWidth} />;
};
